/**
 * Carga la tasa de cambio vigente al arrancar la app y la mantiene en el store.
 * El POS y el TasaBadge la leen desde ahi.
 */
import { useEffect, type ReactNode } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { obtener } from '@/lib/axios';
import { useAuthStore } from '@/store/authStore';
import { useTasaStore } from '@/store/tasaStore';
import type { TasaCambio } from '@/lib/tipos';

export function TasaProvider({ children }: { children: ReactNode }) {
  const autenticado = useAuthStore((s) => Boolean(s.token && s.usuario));
  const establecer = useTasaStore((s) => s.establecer);
  const setCargando = useTasaStore((s) => s.setCargando);
  const qc = useQueryClient();
  const vigente = useQuery({
    queryKey: ['tasa', 'vigente'],
    queryFn: () => obtener<TasaCambio | null>('/tasas-cambio/vigente'),
    enabled: autenticado,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
  });

  useEffect(() => {
    if (!autenticado) { establecer(null); return; }
    setCargando(vigente.isPending);
    if (vigente.data !== undefined) establecer(vigente.data);
  }, [autenticado, vigente.data, vigente.isPending, establecer, setCargando]);

  useEffect(() => {
    if (!autenticado || vigente.data === undefined) return;
    void qc.invalidateQueries({ queryKey: ['productos'] });
    void qc.invalidateQueries({ queryKey: ['prodBuscar'] });
  }, [autenticado, vigente.data?.id, vigente.data?.tasa, qc]);

  return <>{children}</>;
}
